export default __webpack_public_path__ + "static/media/delivery-icon-45min.e1005465.png";